/**
 * Single source of truth for the device-API origin.
 *
 * STAGING BUILD (branch `compat-staging`): points at the Kegtron Pro compat
 * layer instead of mdash.net. Production (dash.kegtron.com / Netlify) still
 * builds from `master`, which keeps `https://mdash.net`.
 *
 * NOTE: this is hardcoded rather than env-driven on purpose. preact-cli only
 * DefinePlugin-substitutes `PREACT_APP_*` keys that are actually present in
 * `process.env` at build time; an unset key survives into the bundle as a
 * literal `process.env.PREACT_APP_…`, which throws `process is not defined`
 * in the browser. There is no existing `process.env` usage in src/ to
 * piggyback on, so a hardcoded constant is the safe option here.
 *
 * Imported by the service worker as well as app code, so keep this module
 * free of side effects and free of DOM/app dependencies.
 */

/** Origin the app talks to for all device/customer API calls. */
export const API_ORIGIN = 'https://pro-compat.api.kegtron.com';

/**
 * Hostnames that serve the mDash-compatible device API. The legacy mdash.net
 * host is retained so a client that still has an in-flight legacy URL (or a
 * cached SW route) keeps behaving identically.
 */
export const API_HOSTS = ['pro-compat.api.kegtron.com', 'mdash.net'];

/**
 * True when a URL (or bare hostname) belongs to the device API.
 * @param {string} value - Full URL or hostname
 * @returns {boolean}
 */
export function isApiUrl(value) {
  if (!value) return false;
  return API_HOSTS.some((host) => value.includes(host));
}
